import { Markdown } from "../components/Markdown"
import { ForestTemplate } from "../templates/ForestTemplate"

export function RegistryPage() {
  return (
    <ForestTemplate title="Registry - Blake & Christie">
      <Markdown path="registry.md" />
    </ForestTemplate>
  )
}
